import { mapGetters } from "vuex";
import { uploadFile, uploadFileMulti } from "@/plugins/uploadFile";
import { dataURLtoFile } from "@/plugins/util";
import { openEmojiPanel } from "@/views/wiki/components/emoji";

export default {
  props: {
    // 编辑框占位文案
    placeholder: {
      type: String,
      default: "说点什么吧"
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 确认按钮文案
    sendBtnText: {
      type: String,
      default: "发 布"
    },
    // 是否显示上传视频按钮
    showVideo: {
      type: Boolean,
      default: true
    },
    // 是否显示上传视频按钮
    showImg: {
      type: Boolean,
      default: true
    },
    isShowEdit: {
      type: Boolean,
      default: true
    },
    // 确定按钮回调
    onOk: {
      type: Function,
      default: null
    },
    // 是否显示取消按钮
    showCancel: { type: Boolean, default: false },
    // 是否显示工具栏
    showToolBar: { type: Boolean, default: true }
  },
  model: {},
  components: {},
  data() {
    return {
      savedRange: null,
      resources: [],
      autoFocusTimer: null
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUser"])
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    uploadImg(e) {
      let file = e.target.files[0];
      let item = {
        file: file,
        percent: 0,
        type: "img",
        url: "",
        key: parseInt(Math.random() * 1000000)
      };
      this.resources.push(item);
      uploadFile({
        file,
        percent: 0,
        progressCb: percent => {
          item.percent = percent;
        }
      }).then(res => {
        item.percent = 100;
        item.url = res.url;
      });
    },
    async uploadVideo(e) {
      let file = e.target.files[0];
      let item = {
        file: file,
        percent: 0,
        type: "video",
        videoUrl: "",
        url: "",
        key: parseInt(Math.random() * 1000000)
      };
      this.resources.push(item);
      await this.getVideoPoster(file).then(base64Url => {
        // console.log(base64Url);
        if (base64Url.length > 17) {
          let imgFile = dataURLtoFile(base64Url, "img.png");
          uploadFile({
            file: imgFile,
            is_video: true
          }).then(res => {
            item.url = res.url;
          });
        }
      });
      let params = {
        file,
        is_video: true,
        progressCb: function(percent) {
          item.percent = percent;
        }
      };
      uploadFileMulti(params).then(res => {
        item.percent = 100;
        item.videoUrl = res.url;
      });
    },
    getVideoPoster(file) {
      console.log(file);
      return new Promise((resolve, reject) => {
        let url = window.URL.createObjectURL(file);
        let videoDom = document.createElement("video");
        videoDom.setAttribute("crossOrigin", "Anonymous");
        // videoDom.currentTime = 1;
        videoDom.muted = true;
        videoDom.autoplay = true;
        videoDom.addEventListener("loadeddata", function() {
          let h = videoDom.videoHeight;
          let w = videoDom.videoWidth;
          if (w > 500) {
            h = (500 / w) * h;
            w = 500;
          }
          console.log(h, w);
          let canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(videoDom, 0, 0, w, h);
          let _url = canvas.toDataURL("image/png");
          resolve(_url);
        });
        videoDom.src = url;
      });
    },
    onCloseImg(index) {
      this.resources.splice(index, 1);
    },

    _onOk() {
      let isUpdate = true;
      this.resources.forEach(item => {
        if (item.percent < 100) {
          isUpdate = false;
        }
      });
      if (!isUpdate) {
        this.$message("还有资源未上传完成");
        return;
      }
      const text = this.$refs.textBox.innerHTML || "";
      if (text.trim() == "") {
        this.$message("内容为空，请重新输入！");
        return;
      }
      const data = this.formatData();
      if (this.onOk) {
        this.onOk(data);
      }
    },
    onClear() {
      this.$refs.textBox.innerHTML = "";
      this.resources = [];
    },
    onEnter() {
      this._onOk();
    },
    onCtrlEnter(event) {
      if (event.code === "Enter") {
        document.execCommand("insertText", false, "\n");
      }
    },
    handleInput() {
      const text = this.$refs.textBox.innerHTML;
      if (text.length === 1 && !text.trim()) {
        this.$refs.textBox.innerHTML = "";
      }
    },
    handleFocus() {
      const savedRange = this.savedRange;
      if (savedRange) {
        const selection = window.getSelection();
        selection.removeAllRanges(); // 清除当前选择
        selection.addRange(savedRange); // 恢复光标
      }
      this.$emit("focus");
    },
    onBlur() {
      console.log("失去焦点");
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const savedRange = selection.getRangeAt(0); // 存储 Range
        console.log(savedRange);
        this.savedRange = savedRange;
      }
    },
    async handleOpenEmojiPanel() {
      console.log("click 打开表情面板");
      this.$refs.textBox.focus();

      // this.autoFocusTimer = setInterval(() => {
      //   this.$refs.textBox.focus();
      // }, 100);
      const emoji = await openEmojiPanel(this.$refs.emojiTippyRef)
        .then(value => value)
        .catch(() => null);
      if (!emoji) return;
      console.log("==插入表情", emoji.name);

      let sel, range;
      if (window.getSelection && (sel = window.getSelection()).rangeCount) {
        range = sel.getRangeAt(0);
        range.collapse(true);
        const img = document.createElement("img");
        img.style.width = "20px";
        img.style.height = "20px";
        img.src = emoji.icon;
        img.dataset.emoji = emoji.name;
        img.alt = emoji.name;
        range.insertNode(img);

        range.setStartAfter(img);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
      clearInterval(this.autoFocusTimer);
    },
    formatData() {
      const html = this.$refs.textBox.innerHTML || "";
      const text = html.replace(/<img[^>]*alt="([^"]*)"[^>]*>/g, "$1");
      let contentJson = [{ type: "paragraph", children: [{ text: text }] }];
      let thumb = [];
      this.resources.forEach(item => {
        if (item.type == "img") {
          // 一行一个
          const imgJson = {
            type: "paragraph",
            children: [
              { text: "" },
              {
                type: "image",
                key: Math.random()
                  .toString(8)
                  .slice(2),
                src: item.url,
                alt: "",
                isAdaptive: true,
                style: {},
                children: [{ text: "" }]
              },
              { text: "" }
            ]
          };
          contentJson.push(imgJson);
          if (thumb.length < 3) {
            thumb.push(item.url);
          }
        } else if (item.type == "video") {
          const videoJson = {
            type: "video",
            src: item.videoUrl,
            poster: item.url,
            children: [{ text: "" }]
          };
          contentJson.push(videoJson);
        }
      });

      return {
        text,
        resources: this.resources,
        contentJson,
        thumb
      };
    }
  }
};
